module.exports = __webpack_public_path__ + "media/images/photo/Residential/slider3-3629be55e24bea6ea12d388c99e81cfc.svg";